import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Parameters from 'selective_solder_fixtures/components/Parameters';
import Pricing from 'selective_solder_fixtures/components/Pricing';

import { changeParameter, validator } from 'selective_solder_fixtures/store/slice';
import { selectDataForApp } from 'selective_solder_fixtures/store/selectors';
import { doQuote } from 'selective_solder_fixtures/store/thunks';
import ToasterComponent from 'shared/components/ToasterComponent';

const App = () => {
  const dispatch = useDispatch();
  // eslint-disable-next-line no-unused-vars
  const { validatorFlag, parameters, quote } = useSelector(selectDataForApp);

  const onChangeParameter = (name, value) => {
    dispatch(changeParameter({ name, value }));
    dispatch(doQuote({ name, value }));
  };

  return (
    <div className="container-fluid container-lg pt-4 pt-xl-0">
      <ToasterComponent />
      <div className="row">
        <div className="col-lg-4">
          <div className="card parameters h-100">
            <div className="card-body">
              <Parameters
                parameters={parameters}
                onChangeParameter={onChangeParameter}
                validator={validator} />
            </div>
          </div>
        </div>
        <div className="col-lg-8">
          <div className="second-section">
            <div className="container">
              <Pricing parameters={parameters} quote={quote} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default App;
